import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';

export default function LgpdModal() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          className="text-blue-600 underline"
        >
          ler termos LGPD
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Termos de Tratamento de Dados (LGPD)</DialogTitle>
        </DialogHeader>
        <div className="prose max-w-none text-sm">
          <p>Os dados pessoais informados nesta inscrição serão tratados pela Estudologia exclusivamente para fins do processo seletivo informado.</p>
          <p>Você pode solicitar correção, acesso ou eliminação dos seus dados a qualquer momento.</p>
          <p>Ao marcar a caixa de aceite, você confirma que leu e concorda com este tratamento.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
